import { Draft } from "../models/draft.model";
import { CreateDraftDto } from "./dto/create-draft.dto";
import { createUseApi } from "./useApi";
const config = useRuntimeConfig();
export const drafts = {
  useCreateDraft: createUseApi<CreateDraftDto, Draft>({
    method: "POST",
    url: `${config.public.url}/draft`,
    dataBuilder: (data) => data,
    requireAuthentication: true,
  }),
  useGetOwnDrafts: createUseApi<void, Draft[]>({
    method: "GET",
    url: `${config.public.url}/draft`,
    requireAuthentication: true,
  }),
  useRemoveDraft: createUseApi<string, Draft>({
    method: "DELETE",
    url: (inputData) => `${config.public.url}/draft/${inputData}`,
    requireAuthentication: true,
  }),
  useUpdateDraft: createUseApi<[string, Partial<CreateDraftDto>], Draft>({
    method: "PATCH",
    url: (data) => `${config.public.url}/draft/${data[0]}`,
    dataBuilder: (data) => data[1],
    requireAuthentication: true,
  }),
  useGetDraftById: createUseApi<string, Draft>({
    method: "GET",
    url: (data) => `${config.public.url}/draft/${data}`,
    requireAuthentication: true,
  }),
};
